import React from 'react';
import { CustomerProfile } from '../../components/CustomerProfile/CustomerProfile';
import { validateFeatureFlag } from '../../services/featureFlagService';
import { FEATURE_FLAG } from '../../constants/general';
import ChatBot from '../../flows/chatBot';

export interface PageLayoutProps {
  children: React.ReactNode;
  hideProfile?: boolean;
  hideChatBot?: boolean;
}

const PageLayout = (props: PageLayoutProps) => {
  const { children, hideProfile, hideChatBot } = props;
  return (
    <div className='flex w-dvw justify-center mt-[96px] ml-[100px] pc-md:ml-[256px]'>
      {!hideProfile && <CustomerProfile />}
      {validateFeatureFlag(FEATURE_FLAG.ADA_BETA) && !hideChatBot && (
        <ChatBot chatBotStyle='absolute right-[10px] bottom-[100px] z-40 w-[46px] h-[46px] rounded-full bg-action03 flex items-center justify-center cursor-pointer shadow-helpMenuButton hover:bg-action04' />
      )}
      <div className='pc-md-layout:w-[1300px] w-[1080px]'>{children}</div>
    </div>
  );
};

export default PageLayout;
